import React from "react";
import "./styles/index.scss";
import { useStateCallback } from "../../../../helpers/utils";
import * as api from "../../../../api/generated-api";
import DKFormTextInput from "../../../common/widgets/formVariablesWidget/DKFormTextInput";

type MemberFormProps = {
  title?: string;
  onChange: (member: api.Person) => void;
};

const MemberForm = (props: MemberFormProps) => {
  const { title = "Primary Contact", onChange } = props;
  const initialMember = {
    firstName: undefined,
    lastName: undefined,
    email: undefined,
  };

  const [member, setMember] = useStateCallback(initialMember);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMember({ ...member, [e.target.name]: e.target.value }, (data) => {
      onChange(data);
    });
  };

  return (
    <div className="member-form-container">
      <div className="member-form-title">{title}</div>
      <div className="member-form">
        <div className="member-form-input">
          <DKFormTextInput
            dataTestId="investor-member-first-name-input"
            className="deals-input"
            required
            label="First Name"
            name="firstName"
            type="text"
            fullWidth={true}
            onChange={handleChange}
            value={member.firstName}
            variant="outlined"
          />
        </div>
        <div className="member-form-input">
          <DKFormTextInput
            dataTestId="investor-member-last-name-input"
            className="deals-input"
            required
            label="Last Name"
            name="lastName"
            type="text"
            fullWidth={true}
            onChange={handleChange}
            value={member.lastName}
            variant="outlined"
          />
        </div>
        <div className="member-form-input">
          <DKFormTextInput
            dataTestId="investor-member-email-input"
            className="deals-input"
            required
            label="Email"
            name="email"
            type="email"
            fullWidth={true}
            onChange={handleChange}
            value={member.email}
            variant="outlined"
          />
        </div>
      </div>
    </div>
  );
};

export default MemberForm;
